import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import MobileHeroCard from '../MobileHeroCard';
import { type PackagePickerStoreSlice } from '../../../../../redux/packagePicker/types';
import { formatSaleEndDate } from '../../../utils';
import { usePackagePickerOrderForMobile } from '../../../hooks';
import DiscontinuedPlanDisclaimer from '../_partials/DiscontinuedPlanDisclaimer';
import { useSelector } from 'react-redux';
import { getCoreLevel } from '@wix/da-shared-react/pkg/publicSession/selectors';

import s from './HeroTableMobile.scss';

interface Props {
  sale?: PackagePickerStoreSlice['sale'];
  saleEndDate?: string;
  referer: string;
}

const HeroTableMobile: FC<Props> = ({ sale, saleEndDate, referer }) => {
  const { t } = useTranslation();
  const packagePickerOrder = usePackagePickerOrderForMobile();
  const userCoreLevel = useSelector(getCoreLevel);
  const isCoreAccess = userCoreLevel === 'core_access';

  return (
    <>
      {packagePickerOrder.map(coreType => (
        <MobileHeroCard key={coreType} coreType={coreType} referer={referer} />
      ))}
      {isCoreAccess && (
        <DiscontinuedPlanDisclaimer
          className={s['discountinued-plan-disclaimer']}
        />
      )}
      <div className={s['disclaimer']}>
        {sale?.ppShowLegal &&
          saleEndDate &&
          t('packagePicker.heroTable.saleDisclaimer', {
            endDate: formatSaleEndDate(saleEndDate),
          })}
        {!sale && t('packagePicker.billingCycle.new.pricesAreYearlyDisclaimer')}
        {t('packagePicker.billingCycle.new.finalPriceDisclaimer')}
      </div>
    </>
  );
};

export default HeroTableMobile;
